import { stringify } from 'query-string';

import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'AWS_SIGNATURE_GET',
  GET_SUCCESS: 'AWS_SIGNED_KEY_GET_SUCCESS',
  GET_FAILURE: 'AWS_SIGNED_KEY_GET_FAILURE',
  INVALIDATE_ITEM: 'AWS_SIGNED_KEY_INVALIDATE_ITEM',
};

export const get = actions.get(
  (studentId, query) =>
    `${BASE_URL}/students/${studentId}/video-signed-key/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = (id, query) => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
      query,
    },
  });
};
